// Template types shared by the platform admin editor and the campaign-side
// reader. The icon component is picked by key, so storing just the string key
// in Firestore keeps the schema stable while letting the UI evolve.

import {
  LuBarChart3,
  LuCalendar,
  LuClipboardCheck,
  LuCoins,
  LuFiles,
  LuGlobe,
  LuMail,
  LuMegaphone,
  LuMessageSquare,
  LuPhone,
  LuSend,
  LuSettings,
  LuShare2,
  LuStore,
  LuUser,
  LuUsers,
} from "react-icons/lu";

export const TEMPLATE_TYPES = [
  { key: "email", label: "Email", icon: LuMail },
  { key: "social", label: "Social Media Posts", icon: LuShare2 },
  { key: "promotion", label: "Campaign Promotion", icon: LuMegaphone },
  { key: "send", label: "Send", icon: LuSend },
  { key: "outreach", label: "Direct Outreach", icon: LuUser },
  { key: "materials", label: "Campaign Materials", icon: LuFiles },
  { key: "phone", label: "Phone Call", icon: LuPhone },
  { key: "sms", label: "Text / SMS", icon: LuMessageSquare },
  { key: "website", label: "Website", icon: LuGlobe },
  { key: "event", label: "Event", icon: LuCalendar },
  { key: "volunteers", label: "Volunteers", icon: LuUsers },
  { key: "businesses", label: "Businesses", icon: LuStore },
  { key: "fundraising", label: "Fundraising", icon: LuCoins },
  { key: "analytics", label: "Analytics / Results", icon: LuBarChart3 },
  { key: "checklist", label: "Checklist", icon: LuClipboardCheck },
  { key: "settings", label: "Settings", icon: LuSettings },
];

export const TEMPLATE_TYPE_BY_KEY = Object.fromEntries(
  TEMPLATE_TYPES.map((t) => [t.key, t]),
);

// Fallback used when a template has no `type` set (older rows pre-dating the
// field) or when the stored key doesn't match any known entry.
export const DEFAULT_TEMPLATE_TYPE = {
  key: "",
  label: "Template",
  icon: LuFiles,
};

export const resolveTemplateType = (key) =>
  TEMPLATE_TYPE_BY_KEY[key] || DEFAULT_TEMPLATE_TYPE;
